{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "Con verein.Cloud® offriamo valore aggiunto e fonti di reddito per le associazioni che vanno oltre i guadagni derivanti dalle quote associative. Una piattaforma di donazioni crea accesso automatizzato al finanziamento di piani e progetti. Con l'accesso profilato ai membri del club, i club possono integrare i loro sponsor in modo più sostenibile. Membri e associazioni beneficiano di funzioni di fedeltà, buoni o cashback e altri valori aggiunti e servizi.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "È stato inviato un link per il ripristino della password. Controlla la tua casella di posta per un'email da support@verein.cloud.",
  "New Version is Available.": "È disponibile una nuova versione.",
  "Please Click to Update": "Fai clic per aggiornare",
  "Forgot Password": "Password dimenticata",
  "Back to login": "Torna al login",
  "Submit": "Invia",
  "Welcome": "Benvenuto",
  "Login Successful": "Accesso riuscito",
  "Admin": "Amministratore",
  "Member": "Membro",
  "Guest": "Ospite",
  "Secretary": "Segretario",
  "Functionary": "Funzionario",
  "Editor": "Editore",
  "User": "Utente",
  "Member Light": "Membro Light",
  "Member Light Admin": "Amministratore Membro Light",
  "About": "Informazioni",
  "Chairman": "Presidente",
  "Hello world !": "Ciao Mondo !",
  "Not Found": "Non Trovato",
  "Unauthorized Access": "Accesso non autorizzato",
  "Home": "Inizio",
  "Logged in as": "Autenticato come",
  "Login": "Entrare",
  "Logout": "Uscire",
  "Password": "Password",
  "Password is required": "La password é richiesta",
  "Username": "Identificativo",
  "Username is required": "L'identificativo é richiesto",
  "Username or password incorrect.": "Identificativo o password incorretti.",
  "Remember me": "Ricordami",
  "Version": "Versione",
  "Details": "Dettagli",
  "Yes": "Sì",
  "No": "No",
  "Old Password": "Vecchia Password",
  "New Password": "Nuova Password",
  "Confirm Password": "Conferma password",
  "Confirmation": "Conferma",
  "Delete Confirmation": "Conferma Eliminazione",
  "Move to Trash Confirmation": "Conferma Spostamento nel Cestino",
  "Leave Confirmation": "Conferma Uscita",
  "Join Confirmation": "Conferma Iscrizione",
  "Approve Join Confirmation": "Conferma Approvazione Iscrizione",
  "Accept Confirmation": "Conferma Accettazione",
  "Deny Confirmation": "Conferma Rifiuto",
  "Approve Confirmation": "Conferma Approvazione",
  "Reject Confirmation": "Conferma Rifiuto",
  "Shifts Delete Confirmation": "Conferma Eliminazione Turni",
  "Accept Successful": "Accettazione riuscita",
  "Deny Successful": "Rifiuto riuscito",
  "Unapprove Successful": "Disapprovazione riuscita",
  "Approve Successful": "Approvazione riuscita",
  "Created Successfully": "Creato con successo",
  "Update Successful": "Aggiornamento riuscito",
  "Delete Successful": "Eliminazione riuscita",
  "Leave Successful": "Uscita riuscita",
  "Join Successful": "Partecipazione riuscita",
  "Approved Successfully": "Approvato con successo",
  "Rejected Successfully": "Rifiutato con successo",
  "Message starred successfully": "Messaggio contrassegnato con successo",
  "Message moved to inbox successfully": "Messaggio spostato nella posta in arrivo con successo",
  "Message saved as draft successfully": "Messaggio salvato come bozza con successo",
  "Message moved to trash successfully": "Messaggio spostato nel cestino con successo",
  "Error": "Errore",
  "Something went wrong": "Qualcosa è andato storto!",
  "Are you sure you want to continue": "Sei sicuro di voler continuare",
  "Are you sure you want to delete": "Sei sicuro di voler eliminare",
  "Are you sure you want to leave": "Sei sicuro di voler uscire",
  "Are you sure you want to join": "Sei sicuro di voler unirti",
  "Are you sure you want to join {eventName} event on {eventDate}?": "Sei sicuro di voler partecipare all'evento <b>'{{eventName}}'</b> il <b>{{eventDate}}</b>?",
  "Are you sure you want to join {eventName} for all upcoming events?": "Sei sicuro di voler partecipare a <b>'{{eventName}}'</b> per tutti gli eventi futuri?",
  "Are you sure you want to join {eventName} event on selected dates?": "Sei sicuro di voler partecipare all'evento <b>'{{eventName}}'</b> nelle date selezionate?",
  "Your current Request is waiting for the Approval": "La tua richiesta attuale è in attesa di approvazione.",
  "Current Request is waiting for the Approval by Admin": "La richiesta attuale è in attesa dell'approvazione da parte dell'amministratore.",
  "Current request has been denied": "La richiesta attuale è stata rifiutata",
  "Your current request is Rejected": "La tua richiesta attuale è stata rifiutata",
  "Your current request is Approved": "La tua richiesta attuale è stata approvata",
  "Deny Reason": "Motivo del rifiuto",
  "Your current Request is waiting for the Approval by Admin": "La tua richiesta attuale è in attesa dell'approvazione da parte dell'amministratore.",
  "Your current request is Denied by Admin": "La tua richiesta attuale è stata rifiutata dall'amministratore.",
  "Your update request is waiting for the approval by Admin": "La tua richiesta di aggiornamento è in attesa dell'approvazione da parte dell'amministratore.",
  "Update request is waiting for the approval": "La richiesta di aggiornamento è in attesa dell'approvazione.",
  "You have unsaved changes. Are you sure you want to leave": "Hai delle modifiche non salvate. Sei sicuro di voler uscire",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "Sei sicuro di voler accettare questo ",
  "Are you sure you want to deny this": "Sei sicuro di voler negare questo ",
  "Are you sure you want to approve this": "Sei sicuro di voler approvare questo ",
  "Are you sure you want to reject this": "Sei sicuro di voler rifiutare questo ",
  "Are you sure you want to unapprove this": "Sei sicuro di voler disapprovare questo ",
  "Are you sure you want to accept this Course": "Sei sicuro di voler accettare questo corso",
  "Are you sure you want to deny this Course": "Sei sicuro di voler rifiutare questo corso",
  "Are you sure you want to approve this Course": "Sei sicuro di voler approvare questo corso",
  "Are you sure you want to reject this Course": "Sei sicuro di voler respingere questo corso",
  "Are you sure you want to unapprove this Course": "Sei sicuro di voler disapprovare questo corso",
  "Are you sure you want to accept this Event": "Sei sicuro di voler accettare questo evento",
  "Are you sure you want to deny this Event": "Sei sicuro di voler rifiutare questo evento",
  "Are you sure you want to approve this Event": "Sei sicuro di voler approvare questo evento",
  "Are you sure you want to reject this Event": "Sei sicuro di voler respingere questo evento",
  "Are you sure you want to unapprove this Event": "Sei sicuro di voler disapprovare questo evento",
  "Are you sure you want to accept this News": "Sei sicuro di voler accettare questa notizia",
  "Are you sure you want to deny this News": "Sei sicuro di voler rifiutare questa notizia",
  "Are you sure you want to approve this News": "Sei sicuro di voler approvare questa notizia",
  "Are you sure you want to reject this News": "Sei sicuro di voler respingere questa notizia",
  "Are you sure you want to unapprove this News": "Sei sicuro di voler disapprovare questa notizia",
  "Are you sure you want to accept this Task": "Sei sicuro di voler accettare questa attività",
  "Are you sure you want to deny this Task": "Sei sicuro di voler rifiutare questa attività",
  "Are you sure you want to approve this Task": "Sei sicuro di voler approvare questa attività",
  "Are you sure you want to reject this Task": "Sei sicuro di voler respingere questa attività",
  "Are you sure you want to unapprove this Task": "Sei sicuro di voler disapprovare questa attività",
  "Are you sure you want to accept this Group": "Sei sicuro di voler accettare questo gruppo",
  "Are you sure you want to deny this Group": "Sei sicuro di voler rifiutare questo gruppo",
  "Are you sure you want to approve this Group": "Sei sicuro di voler approvare questo gruppo",
  "Are you sure you want to reject this Group": "Sei sicuro di voler respingere questo gruppo",
  "Are you sure you want to unapprove this Group": "Sei sicuro di voler disapprovare questo gruppo",
  "Are you sure you want to accept this FAQ": "Sei sicuro di voler accettare queste domande frequenti",
  "Are you sure you want to deny this FAQ": "Sei sicuro di voler rifiutare queste domande frequenti",
  "Are you sure you want to approve this FAQ": "Sei sicuro di voler approvare queste domande frequenti",
  "Are you sure you want to reject this FAQ": "Sei sicuro di voler respingere queste domande frequenti",
  "Are you sure you want to unapprove this FAQ": "Sei sicuro di voler disapprovare queste domande frequenti",
  "Are you sure you want to accept this Instructor": "Sei sicuro di voler accettare questo istruttore",
  "Are you sure you want to deny this Instructor": "Sei sicuro di voler rifiutare questo istruttore",
  "Are you sure you want to approve this Instructor": "Sei sicuro di voler approvare questo istruttore",
  "Are you sure you want to reject this Instructor": "Sei sicuro di voler respingere questo istruttore",
  "Are you sure you want to unapprove this Instructor": "Sei sicuro di voler disapprovare questo istruttore",
  "Are you sure you want to accept this Room": "Sei sicuro di voler accettare questa stanza",
  "Are you sure you want to deny this Room": "Sei sicuro di voler rifiutare questa stanza",
  "Are you sure you want to approve this Room": "Sei sicuro di voler approvare questa stanza",
  "Are you sure you want to reject this Room": "Sei sicuro di voler respingere questa stanza",
  "Are you sure you want to unapprove this Room": "Sei sicuro di voler disapprovare questa stanza",
  "Are you sure you want to accept this Survey": "Sei sicuro di voler accettare questo sondaggio",
  "Are you sure you want to deny this Survey": "Sei sicuro di voler rifiutare questo sondaggio",
  "Are you sure you want to approve this Survey": "Sei sicuro di voler approvare questo sondaggio",
  "Are you sure you want to reject this Survey": "Sei sicuro di voler respingere questo sondaggio",
  "Are you sure you want to unapprove this Survey": "Sei sicuro di voler disapprovare questo sondaggio",
  "Are you sure you want to delete all shifts for": "Sei sicuro di voler eliminare tutti i turni per",
  "Are you sure you want to move this to trash": "Sei sicuro di voler spostare questo nel cestino",
  "Are you sure you want to permanently delete this": "Sei sicuro di voler eliminare definitivamente questo",
  "Are you sure you want to approve this join request": "Sei sicuro di voler approvare questa richiesta di partecipazione",
  "Are you sure you want to delete this image": "Sei sicuro di voler eliminare questa immagine",
  "Are you sure you want to delete this document": "Sei sicuro di voler eliminare questo documento",
  "Are you sure you want to complete this task": "Sei sicuro di voler completare questo compito",
  "Club Surveys": "Sondaggi di club",
  "Active Polls": "Sondaggi attivi",
  "My Polls": "I miei sondaggi",
  "Completed Polls": "Sondaggi completati",
  "Completed Surveys": "Sondaggi completati",
  "Opinion Poll": "Sondaggio di opinione",
  "owner": "Proprietario",
  "Active on": "Attivo su",
  "Active from": "Attivo dal",
  "Expired on": "Scaduto il",
  "remaining time": "Tempo rimanente",
  "status": "Stato",
  "Add Survey": "Aggiungi sondaggio",
  "View Survey": "Visualizza Sondaggio",
  "Delete Survey": "elimina sondaggio",
  "Active Survey": "Sondaggio attivo",
  "Close Survey": "Chiudi sondaggio",
  "Survey Activated Successfully": "Sondaggio attivato con successo",
  "Survey Closed Successfully": "Sondaggio chiuso con successo",
  "Survey Close Confirmation": "Conferma chiusura sondaggio",
  "Survey Active Confirmation": "Conferma attivazione sondaggio",
  "Are you sure you want to active": "Sei sicuro di voler attivare",
  "Are you sure you want to close": "Sei sicuro di voler chiudere",
  "Leave": "Lascia",
  "Edit": "Modifica",
  "Delete": "Elimina",
  "Remove": "Rimuovi",
  "Add": "Aggiungi",
  "Create": "Crea",
  "Save": "Salva",
  "Update": "Aggiorna",
  "update": "Aggiorna",
  "Cancel": "Annulla",
  "Back": "Indietro",
  "accept": "Accetta",
  "Accept": "Accetta",
  "Decline": "Rifiuta",
  "deny": "Nega",
  "Deny": "Nega",
  "view": "Visualizza",
  "View": "Visualizza",
  "view survey": "Visualizza Sondaggio",
  "view task": "Visualizza Compito",
  "View Task": "Visualizza Compito",
  "Drag and drop image here, or click to add image": "Trascina e rilascia l'immagine qui, o clicca per aggiungere un'immagine",
  "Drag and drop image here, or click to change image": "Trascina e rilascia l'immagine qui, o clicca per cambiare l'immagine",
  "Drag and drop file here, or click to add file": "Trascina e rilascia il file qui, o clicca per aggiungere un file",
  "Drag and drop file here, or click to change file": "Trascina e rilascia il file qui, o clicca per cambiare il file",
  "Add Image": "Aggiungi immagine",
  "Add File": "Aggiungi file",
  "Change Image": "Cambia immagine",
  "Change File": "Cambia file",
  "View more": "Visualizza altro",
  "Notifications": "Notifiche",
  "See more Notifications": "Vedi altre notifiche",
  "Title": "Titolo",
  "Start Date": "Data d'inizio",
  "End Date": "Data di fine",
  "New Survey": "Nuovo sondaggio",
  "Survey Edit": "Modifica sondaggio",
  "Survey Details": "Dettagli del sondaggio",
  "Survey": "Sondaggio",
  "Question": "Domanda",
  "Single selection": "Selezione singola",
  "Multiple selection": "Selezione multipla",
  "Add Choice": "Aggiungi scelta",
  "Enter your question": "Inserisci la tua domanda",
  "Publish": "Pubblica",
  "Add Question": "Aggiungi domanda",
  "Enter your survey name": "Inserisci il nome del tuo sondaggio",
  "Assigned tasks": "Compiti assegnati",
  "About event": "Informazioni sull'evento",
  "Event details": "Dettagli dell'evento",
  "Clear All": "Cancella tutto",
  "Select Date": "Seleziona data",
  "Select Time": "Seleziona ora",
  "Delete Banner": "Elimina banner",
  "Banner": "Banner",
  "Banners": "Banner",
  "Email Type": "Tipo di e-mail",
  "Subject": "Oggetto",
  "To": "A",
  "Cc": "Cc",
  "Recipients": "Destinatari",
  "Edit Draft Message": "Modifica Bozza",
  "Header Content": "Contenuto dell'intestazione",
  "Template Body": "Corpo del modello",
  "Footer Content": "Contenuto del piè di pagina",
  "Url": "URL",
  "Action": "Azione",
  "Thumbnail": "Miniatura",
  "From": "Da",
  "Template Type": "Tipo di modello",
  "Header Subject": "Oggetto dell'intestazione",
  "Email Template": "Modello di e-mail",
  "Create Email Template": "Crea modello di e-mail",
  "Content": "Contenuto",
  "instructor": "Istruttore",
  "survey": "Sondaggio",
  "course": "Corso",
  "updatedcourse": "Corso Aggiornato",
  "Select Option": "Seleziona Opzione",
  "Select Options": "Seleziona Opzioni",
  "Tag": "Tag",
  "Tags": "Tag",
  "Tag Name": "Nome del Tag",
  "Create Tag": "Crea Tag",
  "Instructor Tag Name": "Nome del Tag dell'Istruttore",
  "Room Tag Name": "Nome del Tag della Stanza",
  "Courses": "Corsi",
  "Instructor": "Istruttore",
  "Room": "Stanza",
  "Rooms": "Stanze",
  "New Tag": "Nuovo Tag",
  "Task": "Compito",
  "task": "Compito",
  "Event": "Evento",
  "Events": "Eventi",
  "Event Name": "Nome dell'evento",
  "Event Type": "Tipo di evento",
  "FAQs": "FAQ",
  "Surveys": "Sondaggi",
  "News": "Notizie",
  "news": "Notizie",
  "news posts": "Articoli delle Notizie",
  "news post": "Articolo delle Notizie",
  "create news post": "Crea Articolo delle Notizie",
  "edit news post": "Modifica Articolo delle Notizie",
  "news post details": "Dettagli dell'Articolo delle Notizie",
  "discover": "Scopri",
  "create news": "Crea notizie",
  "news from the groups": "Notizie dai gruppi",
  "No Available Content": "Nessun contenuto disponibile",
  "re you sure you want to delete this Tag?": "Sei sicuro di voler eliminare questo Tag?",
  "Update Tag": "Aggiorna Tag",
  "Add task": "Aggiungi compito",
  "Tasks": "Compiti",
  "Task details": "Dettagli del compito",
  "Create task": "Crea compito",
  "Edit task": "Modifica compito",
  "All tasks": "Tutti i compiti",
  "My tasks": "I miei compiti",
  "Completed tasks": "Compiti completati",
  "Open tasks": "Compiti aperti",
  "Group tasks": "Compiti di gruppo",
  "New task": "Nuovo compito",
  "Subtasks": "Sotto-compiti",
  "Add Sub-task": "Aggiungi sotto-compito",
  "Select date": "Seleziona data",
  "ToDo": "Da fare",
  "In-Progress": "In corso",
  "InProgress": "In corso",
  "Completed": "Completato",
  "Comments": "Commenti",
  "Assigned": "Assegnato",
  "Assign to": "Assegna a",
  "Add a Card": "Aggiungi una carta",
  "Add Card": "Aggiungi carta",
  "Add element": "Aggiungi elemento",
  "Enter a title for this card": "Inserisci un titolo per questa carta",
  "Tasks to be completed": "Compiti da completare",
  "No Available Tasks": "Nessun compito disponibile",
  "Group": "Gruppo",
  "Individual": "Individuale",
  "Task type": "Tipo di compito",
  "Add Tag": "Aggiungi Tag",
  "Enter Title": "Inserisci Titolo",
  "Enter Description": "Inserisci Descrizione",
  "Select": "Seleziona",
  "News Posts": "Articoli delle Notizie",
  "Posts": "Articoli",
  "Message Chats": "Chat di Messaggi",
  "Message": "Messaggio",
  "Chats": "Chat",
  "Tasks Events": "Eventi delle Attività",
  "news from the club": "Notizie dal club",
  "News from the group": "Notizie dal gruppo",
  "News from the Company": "Notizie dall'azienda",
  "Current club dates": "Date attuali del club",
  "Current company dates": "Date attuali dell'azienda",
  "Participant": "Partecipante",
  "Read more": "Leggi di più",
  "Clock": "Orologio",
  "Popular": "Popolare",
  "Latest": "Ultimo",
  "Available Tasks": "Compiti disponibili",
  "Available": "Disponibile",
  "New": "Nuovo",
  "No News": "Nessuna Notizia",
  "Menu": "Menu",
  "Answer Options": "Opzioni di risposta",
  "Enter answer choice": "Inserisci la scelta della risposta",
  "Answer": "Risposta",
  "Survey Type": "Tipo di sondaggio",
  "Type": "Tipo",
  "View Options": "Opzioni di visualizzazione",
  "Notification": "Notifica",
  "Anonymous Voting": "Votazione Anonima",
  "Allow Correcting the Cast Vote": "Consenti la correzione del voto espresso",
  "Multiple Choice": "Scelta multipla",
  "Single Choice": "Scelta singola",
  "Web Notification": "Notifica Web",
  "Email Notification": "Notifica via e-mail",
  "Always": "Sempre",
  "After Voting": "Dopo il voto",
  "Never": "Mai",
  "Al Club": "Tutto il club",
  "All Important Dates": "Tutte le Date Importanti",
  "Jubilees": "Giubilei",
  "Birthdays": "Compleanni",
  "Anniversary": "Anniversario",
  "Birthday": "Compleanno",
  "days ago": "giorni fa",
  "days left": "giorni rimasti",
  "years": "anni",
  "years in club": "anni nel club",
  "Today": "Oggi",
  "Today is": "Oggi è",
  "No upcoming birthdays or anniversaries": "Nessun compleanno o anniversario imminente",
  "Say Congrats": "Auguri",
  "Reply": "Rispondi",
  "Reply All": "Rispondi a tutti",
  "Forward": "Inoltra",
  "No Messages": "Nessun Messaggio",
  "All Events": "Tutti gli Eventi",
  "Club Event": "Evento del Club",
  "Group Event": "Eventi di Gruppo",
  "Functionaries Event": "Evento dei Funzionari",
  "Course": "Corso",
  "Seminar": "Seminario",
  "Items Per Page": "Elementi per pagina",
  "Description": "Descrizione",
  "Enter to search": "Premi Invio per cercare",
  "New Chat": "Nuova Chat",
  "New Email": "Nuova Email",
  "Email": "Email",
  "E-Mail": "Email",
  "Select an email to start communication": "Seleziona un'e-mail per iniziare la comunicazione",
  "Select a chat to start messaging": "Seleziona una chat per iniziare a messaggiare",
  "Looks like you haven’t initiated a conversation with any of your team members": "Sembra che tu non abbia iniziato una conversazione con nessuno dei membri del tuo team",
  "Enter your survey description": "Inserisci la descrizione del tuo sondaggio",
  "Manage members and set their access level in your workspace": "Gestisci i membri e imposta il loro livello di accesso nel tuo spazio di lavoro",
  "New Message": "Nuovo Messaggio",
  "Message Type": "Tipo di Messaggio",
  "Add a subject...": "Aggiungi un oggetto...",
  "Select A Message": "Seleziona un Messaggio",
  "Choose File": "Scegli file",
  "Type a message...": "Digita un messaggio...",
  "Draft": "Bozza",
  "Drafts": "Bozze",
  "Send": "Invia",
  "Bin": "Cestino",
  "All Messages": "Tutti i Messaggi",
  "Posted": "Pubblicato",
  "Marked": "Contrassegnato",
  "Inbox": "Posta in arrivo",
  "Trash": "Cestino",
  "Starred": "Contrassegnato",
  "Sent": "Inviato",
  "All Mails": "Tutte le E-mail",
  "Personal": "Personale",
  "Sorting": "Ordinamento",
  "Active Member": "Membro attivo",
  "Membership number": "Numero di iscrizione",
  "In the team since": "Nel team da",
  "In the club since": "Nel club da",
  "Category": "Categoria",
  "Position": "Posizione",
  "Category Name": "Nome della Categoria",
  "Select Language": "Seleziona Lingua",
  "Select Theme": "Seleziona Tema",
  "No record found": "Nessun record trovato",
  "No items available": "Nessun elemento disponibile",
  "No tags available": "Nessun tag disponibile",
  "Internal": "Interno",
  "External": "Esterno",
  "Booked Out": "Prenotato",
  "Internal Instructor": "Istruttore Interno",
  "External Instructor": "Istruttore Esterno",
  "Instructor Type": "Tipo di Istruttore",
  "Faq Category": "Categoria FAQ",
  "Faq Category Name": "Nome della Categoria FAQ",
  "Sort and Filter": "Ordina e Filtra",
  "Clear": "Cancella",
  "Select Tags": "Seleziona Tag",
  "Name of the Event": "Nome dell'Evento",
  "Venue": "Sede",
  "Add Venue": "Aggiungi Sede",
  "No venue available": "Nessuna sede disponibile",
  "Event Venues": "Sedi degli Eventi",
  "Create Event Venue": "Crea Sede Evento",
  "Event Venue Name": "Nome della Sede Evento",
  "Event Types": "Tipi di Evento",
  "Visibility of Event": "Visibilità dell'Evento",
  "Show Guests": "Mostra Ospiti",
  "Chargeable": "A pagamento",
  "Additional Features": "Caratteristiche Aggiuntive",
  "Event Price": "Prezzo dell'Evento",
  "Assign a task to an event": "Assegna un compito a un evento",
  "Task Description": "Descrizione del Compito",
  "Task Types": "Tipi di Compito",
  "Week Days": "Giorni della Settimana",
  "Recurrence": "Ricorrenza",
  "Start Time": "Ora di Inizio",
  "End Time": "Ora di Fine",
  "Event Date": "Data dell'Evento",
  "Event Time": "Ora dell'Evento",
  "Room No (optional)": "Numero della Stanza (opzionale)",
  "Repeat Event": "Ripeti Evento",
  "Image": "Immagine",
  "Enter Price": "Inserisci il Prezzo",
  "Time From": "Ora Da",
  "Time To": "Ora A",
  "Every": "Ogni",
  "Days": "Giorni",
  "Weeks": "Settimane",
  "Months": "Mesi",
  "Years": "Anni",
  "Day": "Giorno",
  "Repeat Daily": "Ripeti Giornalmente",
  "Repeat Weekly": "Ripeti Settimanalmente",
  "Repeat Monthly": "Ripeti Mensilmente",
  "Repeat Yearly": "Ripeti Annualmente",
  "Public": "Pubblico",
  "Private": "Privato",
  "Club": "Club",
  "Clubs": "Club",
  "Company": "Azienda",
  "Does Not Repeat": "Non si ripete",
  "Every Day": "Ogni Giorno",
  "Every Week": "Ogni Settimana",
  "Every Month": "Ogni Mese",
  "Every Year": "Ogni Anno",
  "Custom": "Personalizzato",
  "Club  Event": "Evento del Club",
  "Select Participants": "Seleziona Partecipanti",
  "Participants": "Partecipanti",
  "Private Group": "Gruppo Privato",
  "Course Information": "Informazioni sul Corso",
  "Place": "Luogo",
  "Date": "Data",
  "Time": "Ora",
  "Instructor Name": "Nome dell'Istruttore",
  "Available Times": "Orari Disponibili",
  "Qualification": "Qualifica",
  "More Courses": "Altri Corsi",
  "Theme": "Tema",
  "Room Information": "Informazioni sulla Stanza",
  "Task Details": "Dettagli del Compito",
  "Assignment": "Assegnazione",
  "Due Date": "Data di Scadenza",
  "Room Details": "Dettagli della Stanza",
  "Address": "Indirizzo",
  "People": "Persone",
  "Pending": "In attesa",
  "Approved": "Approvato",
  "Room Info": "Informazioni sulla Stanza",
  "To be submitted at the of course": "Da presentare alla fine del corso",
  "Add Course": "Aggiungi Corso",
  "Add Location": "Aggiungi Posizione",
  "Add Tags": "Aggiungi Tag",
  "Course Date": "Data del Corso",
  "Allowed Persons": "Persone Ammesse",
  "Add a Title": "Aggiungi un Titolo",
  "Headline": "Titolo",
  "Types": "Tipi",
  "Enter headline": "Inserisci il titolo",
  "Enter content": "Inserisci il contenuto",
  "News Highlight": "Evidenza delle Notizie",
  "Club News": "Notizie del Club",
  "Company News": "Notizie dell'Azienda",
  "New from the club": "Nuovo dal club",
  "New Posts": "Nuovi Articoli",
  "Task Events": "Eventi dei Compiti",
  "Groups": "Gruppi",
  "Group Details": "Dettagli del Gruppo",
  "Delete Group": "Elimina Gruppo",
  "Leave Group": "Lascia Gruppo",
  "Join Group": "Unisciti al Gruppo",
  "Join": "Unisciti",
  "Group Name": "Nome del Gruppo",
  "Course Name": "Nome del Corso",
  "Visibility": "Visibilità",
  "No file chosen": "Nessun file selezionato",
  "Assign a task to course": "Assegna un compito al corso",
  "Please fill all required fields": "Si prega di compilare tutti i campi obbligatori",
  "Room Availability": "Disponibilità della Sala",
  "Room Capacity": "Capacità della Sala",
  "Room Charges": "Tariffe della Sala",
  "Room Current Bookings": "Prenotazioni Attuali della Sala",
  "Instructor Availability": "Disponibilità dell'Istruttore",
  "Instructor Current Bookings": "Prenotazioni Attuali dell'Istruttore",
  "Instructor not available for the following dates and times": "Istruttore non disponibile per le seguenti date e orari",
  "Room not available for the following dates and times": "Sala non disponibile per le seguenti date e orari",
  "Not within availability": "Non all'interno della disponibilità",
  "Add News": "Aggiungi Notizie",
  "Waiting for Approval": "In attesa di approvazione",
  "Are you sure you want to complete this": "Sei sicuro di voler completare questo",
  "Please complete all subtasks before marking the task as completed": "Si prega di completare tutti i sottocompiti prima di contrassegnare il compito come completato",
  "wants to join a Group": "vuole unirsi a un gruppo chiamato",
  "wants to publish an updated Group": "vuole pubblicare un aggiornamento di un gruppo chiamato",
  "has updated the Group": "ha aggiornato il gruppo",
  "invited you to": "ti ha invitato a",
  "wants to publish a Group": "vuole pubblicare un gruppo chiamato",
  "has denied the Group": "ha negato il gruppo",
  "has been added to the Group": "è stato aggiunto al gruppo",
  "has published the Group": "è stato pubblicato il gruppo",
  "wants to publish a News": "vuole pubblicare un articolo chiamato",
  "wants to publish an updated News": "vuole pubblicare un aggiornamento di un articolo chiamato",
  "has denied the News": "ha negato l'articolo",
  "has published the News": "sono state pubblicate le notizie",
  "has updated the News": "sono state aggiornate le notizie",
  "wants to publish an Event": "vuole pubblicare un evento chiamato",
  "wants to publish an updated Event": "vuole pubblicare un aggiornamento di un evento chiamato",
  "has denied the Event": "ha negato l'evento",
  "has published the Event": "è stato pubblicato l'evento",
  "has updated the Event": "è stato aggiornato l'evento",
  "invited you to an Event": "è stato invitato a un evento",
  "has updated Event for existing users": "è stato aggiornato per gli utenti esistenti",
  "wants to publish a Course": "vuole pubblicare un corso chiamato",
  "wants to publish an updated Course": "vuole pubblicare un aggiornamento di un corso chiamato",
  "wants to join a Course you have created": "vuole unirsi a un corso che hai creato",
  "has been added to a Course by the creator": "è stato aggiunto a un corso dal creatore",
  "invited you to a Course": "è stato invitato a un corso",
  "wants to assign Instructor to a Course": "vuole assegnare istruttori a un corso",
  "wants to update assigned Instructor of a Course": "vuole aggiornare gli istruttori assegnati per un corso",
  "has published the Course": "è stato pubblicato il corso",
  "has updated the Course": "è stato aggiornato il corso",
  "has denied the Course": "ha negato il corso",
  "invited you to a Task": "ti ha invitato a un compito",
  "wants to publish a Task": "vuole pubblicare un compito chiamato",
  "wants to publish an updated Task": "vuole pubblicare un aggiornamento di un compito chiamato",
  "has unapproved the Task": "ha compiti non approvati",
  "has unapproved the Subtask": "ha sottocompiti non approvati",
  "has denied the Task": "ha negato il compito",
  "has published the Task": "è stato pubblicato il compito",
  "has updated the Task": "è stato aggiornato il compito",
  "has completed the Task": "ha completato un compito",
  "has sent you a message": "ti ha inviato un messaggio",
  "wants to publish a Survey": "vuole pubblicare un sondaggio chiamato",
  "wants to publish an updated Survey": "vuole pubblicare un aggiornamento di un sondaggio chiamato",
  "has invited you to participate in a Survey": "vi ha invitato a partecipare a un sondaggio",
  "has published the Survey": "è stato pubblicato il sondaggio",
  "has updated the Survey": "è stato aggiornato il sondaggio",
  "has denied the Survey": "ha negato il sondaggio",
  "wants to publish a Room": "vuole pubblicare una stanza",
  "wants to publish an updated Room": "vuole pubblicare una stanza aggiornata",
  "has published the Room": "è stata pubblicata la stanza",
  "has updated the Room": "è stata aggiornata la stanza",
  "has denied the Room": "ha negato la stanza",
  "wants to publish an Instructor": "vuole pubblicare un istruttore",
  "wants to publish an updated Instructor": "vuole pubblicare un istruttore aggiornato",
  "has denied the Instructor": "ha negato l'istruttore",
  "has published the Instructor": "è stato pubblicato l'istruttore",
  "has updated the Instructor": "è stato aggiornato l'istruttore",
  "wants to publish an FAQ": "vuole pubblicare un FAQ",
  "wants to publish an updated FAQ": "vuole pubblicare un FAQ aggiornato",
  "has published the FAQ": "è stato pubblicato il FAQ",
  "wants to publish an updated FAQ to author": "vuole pubblicare un aggiornamento di un FAQ all'autore",
  "has denied the FAQ to author": "ha negato il FAQ all'autore",
  "wants to publish an FAQ category": "vuole pubblicare una categoria di FAQ",
  "Unknown notification type": "Tipo di notifica sconosciuto",
  "Occupancy": "Occupazione",
  "Free": "Libero",
  "Calendar": "Calendario",
  "Jan": "Gen",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "Mag",
  "Jun": "Giu",
  "Jul": "Lug",
  "Aug": "Ago",
  "Sep": "Set",
  "Oct": "Ott",
  "Nov": "Nov",
  "Dec": "Dic",
  "mo": "Lu",
  "tu": "Ma",
  "we": "Me",
  "th": "Gi",
  "fr": "Ve",
  "sa": "Sa",
  "su": "Do",
  "ma 1": "Lu",
  "tu 1": "Ma",
  "we 1": "Me",
  "th 1": "Gi",
  "fr 1": "Ve",
  "sa 1": "Sa",
  "su 1": "Do",
  "current": "Corrente",
  "all": "Tutti",
  "monday": "Lunedì",
  "tuesday": "Martedì",
  "wednesday": "Mercoledì",
  "thursday": "Giovedì",
  "friday": "Venerdì",
  "saturday": "Sabato",
  "sunday": "Domenica",
  "january": "Gennaio",
  "february": "Febbraio",
  "march": "Marzo",
  "april": "Aprile",
  "may": "Maggio",
  "june": "Giugno",
  "july": "Luglio",
  "august": "Agosto",
  "september": "Settembre",
  "october": "Ottobre",
  "november": "Novembre",
  "december": "Dicembre",
  "just now": "proprio adesso",
  "a minute ago": "un minuto fa",
  "minutes ago": "minuti fa",
  "an hour ago": "un'ora fa",
  "hours ago": "ore fa",
  "yesterday": "ieri",
  "a week ago": "una settimana fa",
  "weeks ago": "settimane fa",
  "Click to download": "Clicca per scaricare",
  "Survey Results": "Risultati del Sondaggio",
  "Survey Results Details": "Dettagli dei Risultati del Sondaggio",
  "Survey Created By": "Sondaggio Creato Da",
  "Survey Has been Closed": "Il Sondaggio è Stato Chiuso",
  "You've not voted": "Non hai votato",
  "My Vote": "Il Mio Voto",
  "To Vote": "Per Votare",
  "My Vote: You can select Multiple Options": "Il Mio Voto: Puoi selezionare più opzioni",
  "My Vote: You can select only one option": "Il Mio Voto: Puoi selezionare solo un'opzione",
  "Following people has voted For this option:": "Le seguenti persone hanno votato per questa opzione:",
  "Total Number of Votes for this Option:": "Numero Totale di Voti per questa Opzione:",
  "other": "Altro",
  "Members": "Membri",
  "Search Filter": "Filtro di Ricerca",
  "Search": "Cerca",
  "Search Results": "Risultati della Ricerca",
  "Last Active": "Ultimo Attivo",
  "Status": "Stato",
  "Role": "Ruolo",
  "Online": "Online",
  "Offline": "Offline",
  "List": "Elenco",
  "Members List": "Elenco dei Membri",
  "Created": "Creato",
  "Paid": "Pagato",
  "Unpaid": "Non pagato",
  "Active": "Attivo",
  "Inactive": "Inattivo",
  "Apply Filter": "Applica Filtro",
  "Anonymous": "Anonimo",
  "Show hidden events": "Mostra eventi nascosti",
  "Hide Event": "Nascondi Evento",
  "UnHide Event": "Mostra Evento",
  "Banner Placement": "Posizionamento del Banner",
  "Banner Display Tags": "Tag di Visualizzazione del Banner",
  "Create New Tag": "Crea Nuovo Tag",
  "Task Type": "Tipo di Compito",
  "Leave Event": "Lascia Evento",
  "Join Event": "Partecipa all'Evento",
  "Join This Event": "Partecipa a questo evento",
  "Join All Events in Series": "Partecipa a tutti gli eventi della serie",
  "Join Event on Specific Dates": "Partecipa all'evento in date specifiche",
  "Accept event": "Accetta evento",
  "Deny event": "Rifiuta evento",
  "Publish event": "Pubblica evento",
  "Event Members": "Membri dell'Evento",
  "Event Tasks": "Compiti dell'Evento",
  "Event Details": "Dettagli dell'Evento",
  "About group": "Informazioni sul gruppo",
  "Show more": "Mostra di più",
  "Your team": "Il tuo team",
  "Responsible": "Responsabile",
  "Collaborators": "Collaboratori",
  "Work Shifts": "Turni di Lavoro",
  "Create Work Shift": "Crea Turno di Lavoro",
  "NO Of Shifts": "Numero di Turni",
  "No Shifts Data found": "Nessun dato sui turni trovato",
  "Error while fetching Shifts Details": "Errore durante il recupero dei dettagli dei turni",
  "Shift": "Turno",
  "Form": "Modulo",
  "No new notifications": "Nessuna nuova notifica",
  "No Data": "Nessun Dato",
  "Add Work-shifts to an event": "Aggiungi turni di lavoro a un evento",
  "Click to open details": "Clicca per aprire i dettagli",
  "permanently": "permanentemente",
  "Folder": "Cartella",
  "Star Message": "Messaggio Preferito",
  "Unstar Message": "Messaggio Non Preferito",
  "Impressum": "Note Legali",
  "Terms and Conditions": "Termini e Condizioni",
  "Terms of Use": "Termini di Utilizzo",
  "Privacy Policy": "Politica sulla Privacy",
  "You can find our applicable documents here": "Puoi trovare i nostri documenti applicabili qui",
  "Club Administration": "Amministrazione del Club",
  "Financial Accounting": "Contabilità Finanziaria",
  "License & More": "Licenza e Altro",
  "Documents": "Documenti",
  "Current Statuses": "Stati Attuali",
  "Corporate Philosophy": "Filosofia Aziendale",
  "Corporate": "Aziendale",
  "Archive": "Archivio",
  "All": "Tutti",
  "Tables": "Tabelle",
  "Images": "Immagini",
  "Delete File": "Elimina File",
  "Download File": "Scarica File",
  "Preview Image": "Anteprima immagine",
  "Upload Document": "Carica Documento",
  "Move to My Documents": "Sposta in Documenti",
  "Move to Archived": "Sposta in Archiviato",
  "Move to Current Statuses": "Sposta in Stati Attuali",
  "Move to Club Documents": "Sposta in Documenti del Club",
  "Move to Corporate Documents": "Sposta in Documenti Aziendali",
  "Move to Corporate Philosophy": "Sposta in Filosofia Aziendale",
  "Ascending": "Crescente",
  "Descending": "Decrescente",
  "Order By": "Ordina per",
  "Order": "Ordine",
  "date": "Data",
  "name": "Nome",
  "Are you sure you want to move": "Sei sicuro di voler spostare",
  "Document moved successfully": "Documento spostato con successo",
  "Only PDF files are allowed in Current Statuses": "Solo i file PDF sono ammessi negli Stati Attuali",
  "Upload Successful": "Caricamento Riuscito",
  "Profile": "Profilo",
  "Attachment": "Allegato",
  "Download Attachment": "Scarica Allegato",
  "Author": "Autore",
  "CRM Surveys": "Sondaggi CRM",
  "CRM Survey": "Sondaggio CRM",
  "Voting Results": "Risultati del Voto",
  "Total Votes": "Voti Totali",
  "Votes": "Voti",
  "Close": "Chiudi",
  "Thank you for your vote": "Grazie per il tuo voto",
  "By": "Da",
  "CRM News": "Notizie CRM",
  "Read": "Letto",
  "Mark all notifications as read": "Segna tutte le notifiche come lette",
  "Close this notification": "Chiudi questa notifica",
  "Phone": "Telefono",
  "Published by": "Pubblicato da",
  "Deleted User": "Utente Eliminato",
  "Delete Chat": "Elimina Chat",
  "Availability": "Disponibilità",
  "Enter Name": "Inserisci Nome",
  "Enter Email": "Inserisci Email",
  "Phone No": "Numero di Telefono",
  "Enter Phone No": "Inserisci Numero di Telefono",
  "Enter Address": "Inserisci Indirizzo",
  "No Of Persons": "Numero di Persone",
  "Enter No Of Persons": "Inserisci Numero di Persone",
  "Price": "Prezzo",
  "First Name": "Nome",
  "Enter First Name": "Inserisci Nome",
  "Last Name": "Cognome",
  "Enter Last Name": "Inserisci Cognome",
  "Enter Qualification": "Inserisci Qualifica",
  "Repeat Course": "Ripeti Corso",
  "Delete Selected": "Elimina Selezionato",
  "Deselect All": "Deseleziona Tutto",
  "Statistics": "Statistiche",
  "Clicks": "Clic",
  "Banner Statistics": "Statistiche del Banner",
  "Banner Desktop Clicks": "Clic sul Banner Desktop",
  "Select Admin": "Seleziona Admin",
  "Group Chat": "Chat di Gruppo",
  "Groupchat": "Chat di Gruppo",
  "Personal Chat": "Chat Personale",
  "Created By": "Creato Da",
  "Invoice": "Fattura",
  "Profile Image": "Immagine del Profilo",
  "Share Birthday": "Condividi compleanno",
  "Allow Advertisement": "Consenti Pubblicità",
  "Date From": "Data Da",
  "Date To": "Data A",
  "m ago": "{{count}} minuto(i) fa",
  "h ago": "{{count}} ora(e) fa",
  "d ago": "{{count}} giorno(i) fa",
  "w ago": "{{count}} settimana(e) fa",
  "mo ago": "{{count}} mese(i) fa",
  "Completed Subtasks": "Sottocompiti Completati",
  "Total Subtasks": "Totale Sottocompiti",
  "Task Assigned to": "Compito Assegnato a",
  "To be done by": "Da fare entro",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "Questo compito può essere completato solo da Admin, Organizzatore e Collaboratori di questo compito",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "Non hai il permesso di completare questo sottocompito, solo i partecipanti di questo compito e sottocompiti, l'organizzatore di questo compito e l'amministratore possono completare questo sottocompito",
  "Desktop": "Desktop",
  "Notification Section": "Sezione delle notifiche",
  "Everywhere": "Ovunque",
  "Welcome to your club community!": "Benvenuto nella tua comunità del club!",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Rimani connesso con il tuo club, scambia idee e organizza tutto in un unico posto.",
  "Everything you need for your club - in one place.": "Tutto ciò di cui hai bisogno per il tuo club - in un unico posto.",
  "Simply register, contact members, plan appointments and achieve more together.": "Registrati facilmente, contatta i membri, pianifica appuntamenti e raggiungi di più insieme.",
  "Access important information, share news and collaborate with your team.": "Accedi a informazioni importanti, condividi notizie e collabora con il tuo team.",
  "Happy Birthday": "Buon Compleanno",
  "Happy Anniversary": "Buon Anniversario",
  "Instant and uncomplicated chatting with members or groups": "Chat istantanea e senza complicazioni con membri o gruppi",
  "Your own mailbox based on the classic e-mail": "La tua casella di posta basata sulla classica e-mail",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Tipo o dimensione del file non valido. Sono ammesse solo immagini PNG, JPEG e documenti consentiti di dimensioni inferiori a 10 MB",
  "Club Overview": "Panoramica del Club",
  "Happenings": "Eventi",
  "Occasions": "Occasioni",
  "No:": "No:",
  "Password changed successfully. Please login again": "Password modificata con successo. Effettua nuovamente il login",
  "This is a private group. You need to request to join this group": "Questo è un gruppo privato. Devi richiedere di unirti a questo gruppo",
  "Your request to join this group is pending": "La tua richiesta di unirti a questo gruppo è in sospeso",
  "Your request to join this group has been rejected": "La tua richiesta di unirti a questo gruppo è stata respinta",
  "Confirm Delete": "Conferma Eliminazione",
  "No news has been created in the club yet": "Non sono ancora state create notizie nel club",
  "No news has been created in any Group yet": "Non sono ancora state create notizie in nessun gruppo",
  "No group has been created in the club yet": "Non è stato ancora creato alcun gruppo nel club",
  "No events available": "Nessun evento disponibile",
  "Additional address": "Indirizzo aggiuntivo",
  "You have no notifications": "Non hai notifiche",
  "Information about the course": "Informazioni sul corso",
  "Further information about the course": "Ulteriori informazioni sul corso",
  "Invite Participants": "Invita Partecipanti",
  "Select all": "Seleziona tutto",
  "Unselect all": "Deseleziona tutto",
  "Done": "Fatto",
  "You already have a pending change request": "Hai già una richiesta di modifica in sospeso",
  "Messages": "Messaggi",
  "Calendar view": "Visualizzazione calendario",
  "Card view": "Visualizzazione a schede",
  "Mark As Complete": "Segna come Completato",
  "No Bookings": "Nessuna Prenotazione",
  "Schedule view": "Visualizzazione Programmazione",
  "Hide Empty Slots": "Nascondi Slot Vuoti",
  "Group Filter": "Filtro Gruppo",
  "No Conversation": "Nessuna Conversazione",
  "Select Event Dates": "Seleziona Date dell'Evento",
  "Select the dates you want to join for this event": "Seleziona le date a cui vuoi partecipare per questo evento",
  "Join Selected Dates": "Partecipa alle Date Selezionate",
  "Selected": "Selezionato",
  "dates": "date",
  "new": "nuovo",
  "Please select at least one new date": "Si prega di selezionare almeno una nuova data",
  "No available dates for this event": "Nessuna data disponibile per questo evento",
  "Accept This Event": "Accetta questo evento",
  "Accept All Events in Series": "Accetta tutti gli eventi della serie",
  "Accept Event on Specific Dates": "Accetta l'evento in date specifiche",
  "DIVIDER": "-------------------------------------------------------------DIVIDER---------------------------------------------------------------------",
  "formErrors": {
    "is required.": "è richiesto.",
    "is invalid.": "non è valido.",
    "is required to be at least": "deve essere almeno",
    "cannot be longer than": "non può essere più lungo di",
    "can't be greater than": "non può essere maggiore di",
    "can't be less than": "non può essere minore di",
    "must contain at least 1 in Capital Case!": "deve contenere almeno 1 in maiuscolo!",
    "must contain at least 1 Letter in Small Case!": "deve contenere almeno 1 lettera in minuscolo!",
    "must contain at least 1 Special Character!": "deve contenere almeno 1 carattere speciale!",
    "do not match.": "non corrispondono.",
    "must be unique.": "deve essere unico.",
    "must be greater than 0.": "deve essere maggiore di 0.",
    "must be greater.": "deve essere maggiore.",
    "invalid pattern": "modello non valido",
    "must be greater than or equal.": "deve essere maggiore o uguale.",
    "must be after the start date.": "deve essere dopo la data di inizio.",
    "invalid pattern, 12345-1234 or 12345": "modello non valido, 12345-1234 o 12345"
  },
  "loginForm": {
    "Login into your account": "Accedi al tuo account",
    "Username": "Nome utente",
    "Password": "Password",
    "Remember me": "Ricordami",
    "I forgot my password": "Ho dimenticato la mia password",
    "Don't have an account?": "Non hai un account?",
    "Login": "Accedi",
    "Sign up for Verein.cloud": "Registrati su verein.cloud®",
    "Password (6+ characters)": "Password (6+ caratteri)"
  },
  "buttonComponent": {
    "Login": "Accedi",
    "Success": "Successo",
    "Save": "Salva",
    "Processing": "Elaborazione",
    "Error": "Errore",
    "Cancel": "Annulla",
    "done": "Fatto",
    "Join Event": "Partecipa all'evento",
    "Leave Event": "Lascia l'evento"
  },
  "header": {
    "open": "Apri",
    "close": "Chiudi",
    "start typing": "Inizia a digitare..",
    "messages": "Messaggi"
  },
  "nav": {
    "event members": "Membri dell'evento",
    "event tasks": "Compiti dell'evento",
    "create event form": "Crea modulo evento",
    "dashboard": "Dashboard",
    "news": "Notizie",
    "clubWall": "Muro del Club",
    "community": "Comunità",
    "organizer": "Organizzatore",
    "courses": "Corsi",
    "tasks": "Compiti",
    "events": "Eventi",
    "messages": "Messaggi",
    "settings": "Impostazioni",
    "appointments": "Appuntamenti",
    "messages&groups": "Messaggi & Gruppi",
    "task&appointments": "Compiti & Appuntamenti",
    "myProfile": "Il mio profilo",
    "groups": "Gruppi",
    "academic": "Accademico",
    "app store": "App Store",
    "my profile": "Il mio profilo",
    "profile": "Profilo",
    "club tools": "Strumenti del club",
    "marketing": "Marketing",
    "marketing tools": "Strumenti di Marketing",
    "banners": "Banner",
    "create banner": "Crea banner",
    "emails": "Email",
    "create email": "Crea email",
    "tags": "Tag",
    "survey": "Sondaggi",
    "course management": "Kursverwaltung",
    "club FAQs": "FAQ del club",
    "group details": "Dettagli del gruppo",
    "chat": "Chat",
    "events & club dates": "Eventi e Date del Club",
    "club addons": "Componenti Aggiuntivi del Club",
    "more": "Altro",
    "documents": "Documenti",
    "add": "Aggiungi",
    "faq": "FAQ",
    "my content": "Il Mio Contenuto"
  },
  "dashboard": {
    "news posts": "Articoli di notizie",
    "message chats": "Chat di messaggi",
    "tasks events": "Eventi delle attività",
    "tasks": "Compiti",
    "news from the club": "Notizie dal club",
    "current club dates": "Date attuali del club",
    "participant": "Partecipante",
    "read more": "Leggi di più",
    "clock": "Orologio",
    "popular": "Popolare",
    "latest": "Ultimo",
    "posts": "Articoli",
    "Available Tasks": "Compiti disponibili",
    "message": "Messaggio",
    "chats": "Chat",
    "available": "Disponibile"
  },
  "community": {
    "group overview": "Panoramica del gruppo",
    "dashboard": "Cruscotto",
    "community": "Comunità",
    "messages": "Messaggi",
    "groups": "Gruppi",
    "members": "Membri",
    "open chat": "Apri chat",
    "leave": "Lascia",
    "edit": "Modifica",
    "delete": "Elimina",
    "add": "Aggiungi",
    "create": "Crea",
    "show all groups": "Mostra tutti i gruppi",
    "groups you manage": "Gruppi che gestisci",
    "groups you are a member of": "Gruppi di cui fai parte"
  },
  "groups": {
    "groups": "Gruppi",
    "group": "Gruppo",
    "group details": "Dettagli del gruppo",
    "members": "Membri",
    "news": "Notizie",
    "tasks": "Compiti",
    "events": "Eventi",
    "about": "Informazioni",
    "About this group": "Informazioni su questo gruppo",
    "set": "Set",
    "your team": "Il tuo team",
    "new": "Nuovo",
    "group admin": "Amministratore del gruppo",
    "age": "Età",
    "no group": "Nessun gruppo",
    "no event": "Nessun evento",
    "no task": "Nessun compito",
    "no news": "Nessuna notizia",
    "no member": "Nessun membro",
    "join success message": "Ti sei unito al gruppo con successo.",
    "waiting admin approval": "In attesa dell'approvazione dell'amministratore",
    "leave success message": "Hai lasciato il gruppo con successo.",
    "delete success message": "Gruppo eliminato con successo."
  },
  "banners": {
    "link": "Collegamento",
    "content": "Contenuto",
    "description": "Descrizione",
    "banner status": "Stato",
    "update courses": "Aggiorna corsi",
    "banner invoice": "Fattura",
    "banner category": "Categoria",
    "add description": "Aggiungi descrizione",
    "create banner": "Crea banner",
    "create event": "Crea evento",
    "thumbnail": "Miniatura",
    "add image": "Aggiungi immagine",
    "title": "Titolo",
    "sponsor": "Sponsor",
    "open space": "Spazio aperto",
    "app sponsor": "Sponsor dell'app",
    "group details": "Dettagli del gruppo",
    "all groups": "Tutti i gruppi",
    "all news": "Tutte le notizie",
    "not paid": "Non pagato",
    "save": "Salva",
    "banner link": "Collegamento del banner",
    "cancel": "Annulla",
    "banner categories": "Categorie del banner",
    "banner images": "Immagini del banner",
    "banner title": "Titolo del banner",
    "edit banner": "Modifica banner",
    "banner display": "Visualizzazione",
    "news details": "Dettagli delle notizie",
    "banner placement": "Posizionamento",
    "banner display tag": "Tag di visualizzazione del banner",
    "banner redirect link": "Collegamento di reindirizzamento"
  },
  "dates&filters": {
    "date": "Data",
    "days": "Giorni",
    "day": "Giorno",
    "hour": "Ora",
    "hours": "Ore",
    "time": "Tempo",
    "year": "Anno",
    "years": "Anni",
    "month": "Mese",
    "months": "Mesi",
    "week": "Settimana",
    "weeks": "Settimane",
    "opinion": "Opinione",
    "event type": "Tipo di evento",
    "sort and filter": "Ordina e filtra",
    "clear filters": "Cancella filtri",
    "clear": "Cancella",
    "expired": "Scaduto"
  },
  "messages": {
    "new group": "Nuovo gruppo",
    "new chat": "Nuova chat",
    "chat": "Chat",
    "personal": "Personale",
    "club": "Club",
    "group": "Gruppo",
    "clubs": "Clubs",
    "members": "Membro",
    "write a message": "Scrivi un messaggio",
    "media links and docs": "Media, collegamenti e documenti",
    "group in common": "Gruppo in comune",
    "close": "Chiudi",
    "group name": "Nome del gruppo",
    "cancel": "Annulla",
    "save": "Salva",
    "delete": "Elimina",
    "report": "Segnala"
  },
  "tags": {
    "tag": "Tag",
    "tags": "Tag",
    "tag name": "Nome del tag",
    "create tag": "Crea tag",
    "instructor tag name": "Nome del tag dell'istruttore",
    "room tag name": "Nome del tag della stanza",
    "instructor": "Istruttore",
    "room": "Stanza",
    "new tag": "Nuovo tag"
  },
  "users": {
    "my profile": "Il Mio Profilo",
    "user profile": "Profilo Utente",
    "user": "Utente",
    "general information": "Informazioni Generali",
    "my payment data": "I Miei Dati di Pagamento",
    "association master data": "Dati Maestri dell'Associazione",
    "me at the club": "Io nel club",
    "I in the company": "Io nell'azienda",
    "my address information": "Le Mie Informazioni sull'Indirizzo",
    "communication data": "Dati di Comunicazione",
    "street number": "Numero di Via",
    "more info": "Ulteriori Informazioni",
    "city": "Città",
    "zip code": "Codice Postale",
    "e-mail address": "Indirizzo E-mail",
    "phone number": "Numero di Telefono",
    "date of birth": "Data di Nascita",
    "address supplement": "Complemento d'Indirizzo",
    "save profile": "Salva Profilo",
    "password information": "Informazioni sulla Password",
    "old password": "Vecchia Password",
    "minimum 6 characters": "Minimo 6 caratteri",
    "change": "Cambia",
    "bank holder name": "nome del titolare della banca",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Collegamenti Social",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Homepage",
    "country": "Paese",
    "bank name": "Nome della Banca",
    "member ship start date": "Data di Inizio dell'Abbonamento",
    "My role in verein.cloud®": "Il mio ruolo in verein.cloud®"
  },
  "club_tools": {
    "create question": "Creare domanda",
    "faq categories": "Categorie FAQ",
    "start searching": "Inizia la ricerca",
    "membership": "Iscrizione",
    "maintenance and care": "Manutenzione e cura",
    "create faq": "Crea FAQ",
    "update faq": "Aggiorna FAQ",
    "create title": "Crea titolo",
    "add description here": "Aggiungi descrizione qui"
  },
  "courses": {
    "instructors": "Insegnanti",
    "rooms": "Aule",
    "all instructors": "Tutti gli Insegnanti",
    "all rooms": "Tutte le Aule",
    "today": "Oggi",
    "upcoming": "Prossimi",
    "join": "Unisciti",
    "joined": "Unito",
    "rejected": "Rifiutato",
    "persons": "Persone",
    "search by room name": "Cerca per nome della stanza",
    "join course": "Unisciti al corso",
    "sorting": "Ordinamento",
    "participants": "Partecipanti",
    "about course": "Informazioni sul corso",
    "course details": "Dettagli del corso"
  },
  "appointmentAndClub": {
    "start time": "Ora di inizio",
    "end time": "Ora di fine",
    "visibility": "Visibilità",
    "event name": "Nome dell'evento",
    "event location": "Posizione dell'evento",
    "room number (optional)": "Numero della stanza (opzionale)",
    "event price": "Prezzo dell'evento",
    "additional features": "Caratteristiche aggiuntive",
    "show guests": "Mostra ospiti",
    "chargeable": "A pagamento",
    "create event": "Crea evento",
    "edit event": "Modifica evento",
    "canceled": "Annullato",
    "pending": "In attesa",
    "confirmed": "Confermato",
    "location": "Posizione",
    "responsible": "Responsabile",
    "join event": "Unisciti all'evento",
    "current": "Corrente",
    "tile view": "Vista a mosaico",
    "list view": "Vista elenco",
    "board": "Bacheca",
    "view": "Vista",
    "my contributions": "I miei contributi",
    "Birthdays and anniversaries in the club": "Compleanni e anniversari nel club",
    "Current events in the club": "Eventi attuali nel club",
    "Current events in the company": "Eventi attuali nell'azienda"
  },
  "my content": {
    "title image": "Immagine del titolo",
    "type": "Tipo",
    "actions": "Azioni",
    "faqs": "Domande frequenti"
  },
  "userprofile": {
    "personal information": "Informazioni personali",
    "create profile": "Crea profilo",
    "edit my profile": "Modifica il mio profilo",
    "digital membership card": "Carta di iscrizione digitale",
    "payment information": "Informazioni di pagamento",
    "digital card": "Carta digitale",
    "card holder name": "carta intestata a",
    "card number": "Numero di carta",
    "card type": "Tipo di carta",
    "expiration date": "Data di scadenza",
    "membership information": "Informazioni sull'iscrizione",
    "membership type": "Tipo di iscrizione",
    "membership number": "Numero di iscrizione",
    "In the team since": "Nel team da",
    "approval / activation": "Approvazione / Attivazione",
    "fair-share function": "Funzione di equa condivisione"
  },
  "RRULE": {
    "approximate": "approssimativo",
    "and": "e",
    "at": "alle",
    "day": "giorno",
    "days": "giorni",
    "every": "Ogni",
    "for": "per",
    "hour": "ora",
    "hours": "ore",
    "in": "in",
    "last": "ultimo(i)",
    "minutes": "minuti",
    "month": "mese",
    "months": "mesi",
    "nd": "nd",
    "on the": "il",
    "on": "il",
    "or": "o",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "il",
    "time": "volta",
    "times": "volte",
    "until": "fino a",
    "week": "settimana",
    "weekday": "giorno della settimana",
    "weekdays": "giorni feriali",
    "weeks": "settimane",
    "year": "anno",
    "years": "anni",
    "monthly": "mensile",
    "yearly": "annualmente",
    "weekly": "settimanalmente",
    "daily": "quotidianamente",
    "hourly": "ogni ora",
    "minutely": "ogni minuto",
    "secondly": "ogni secondo",
    "starting from": "a partire da",
    "MO": "lunedì",
    "TU": "martedì",
    "WE": "mercoledì",
    "TH": "giovedì",
    "FR": "venerdì",
    "SA": "sabato",
    "SU": "domenica",
    "RRule error: Unable to fully convert this rrule to text": "Errore RRule: Impossibile convertire completamente questa regola in testo"
  }
}
